// removed by extract-text-webpack-plugin
module.exports = {"HeaderText":"_1FSepeM0I0Ul7Zxztv8f8Y","InformationText":"_25wJHSlbpaiEM3_1157O2b","pMargin":"rtcNPOcto0zBMY3XcDkX-","PasswordFieldWrapper":"_1lbY4bXyiXGBjfnEGxSIdq","PasswordField":"_3QjANEc5KvyoOcqykNKY01","ButtonWrapper":"kBlf_0ZjzBXxo2NDy7JhR","ButtonStyle":"AkNqyR0iNH1VRAr8fT_8p"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/CompanySettings/EndSubscription/style.css
// module id = 809
// module chunks = 0